import { useRef } from "react"
import { Navigate, Routes, useLocation } from "react-router"

export default function AnimatedMainRoutes({ children }) {
	const location = useLocation()
	const initialRedirect = useRef(location.pathname === "/")

	if (initialRedirect.current) {
		initialRedirect.current = false
		return <Navigate to="/php-error" replace />
	}
	return (
		<Routes location={location} key={location.pathname.split("/")[1] || "default"}>
			{children}
		</Routes>
	)
}
